import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { getNPSForm, storeNPSResponseIntoDB } from "../../apis/nps";
import RenderContainer from "../common/components/RenderContainer";
var Nps = function () {
    var config = useMemo(function () { return ({
        fetchForm: function (slug) { return getNPSForm(slug); },
        storeResponse: function (formId, storeData) {
            return storeNPSResponseIntoDB(formId, storeData);
        },
        logPrefix: "NPS",
    }); }, []);
    return _jsx(RenderContainer, { config: config });
};
export default Nps;
